class TableOfContent extends HTMLElement{
    constructor(){
        super();
    }

    connectedCallback(){
        var __this = this;
        // Select all headings that you want to include in the TOC
        const headings = document.querySelector('[data-content]')?.querySelectorAll('h1, h2, h3, h4');

        // Get the TOC container
        const tocContainer = document.getElementById('table-of-contents');

        if (headings.length === 0 || !tocContainer) {
            return;
        }

        // Create a list to hold the TOC entries
        const tocList = document.createElement('ul');
        tocContainer.appendChild(tocList);

        // Iterate over the headings
        headings.forEach(function (heading, index) {
            // Create an ID for the heading if it doesn't have one
            if (!heading.id) {
                heading.id = 'heading-' + index;
            }

            // Create a list item for the TOC
            const tocListItem = document.createElement('li');
            tocListItem.classList.add('toc-level-' + heading.tagName.toLowerCase());

            // Create a link to the heading
            const tocLink = document.createElement('a');
            tocLink.href = '#' + heading.id;
            tocLink.textContent = heading.textContent;

            tocLink.addEventListener('click', function (event) {
                event.preventDefault();
                document.getElementById(heading.id).scrollIntoView({
                    behavior: 'smooth',
                    block: "start",
                    inline: "nearest"
                });
            });

            // Append the link to the list item and the list item to the list
            tocListItem.appendChild(tocLink);
            tocList.appendChild(tocListItem);
        });
    }
}
customElements.define('table-of-content', TableOfContent);
